// extracted by mini-css-extract-plugin
export default {"summaryGrid":"YourData_summaryGrid__dB8oP","summaryElement":"YourData_summaryElement__Y4LVj"};